
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-5b16e2f0\",\"scoped\":true,\"hasInlineConfig\":false}!./CampaignSummarySidebar.css")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CampaignSummarySidebar.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-5b16e2f0\",\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CampaignSummarySidebar.vue"),
  /* scopeId */
  "data-v-5b16e2f0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/nudge-console/create-campaign/summary-sidebar/CampaignSummarySidebar.vue
// module id = bhhA
// module chunks = 1